var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status !== 200)?_c('simple-layouts',{tag:"component"}):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }